import type { CustomField } from '@libs/domain';
import { type LedgerType, ledgerType } from '@libs/enums';

class CustomFieldLedgerSetting implements Pick<CustomField['schema'], 'ledger'> {
  public constructor(
    readonly ledger: LedgerType,
    readonly detail: CustomFieldLedgerSettingDetail[],
  ) {}

  static fromRaw(raw: CustomFieldLedgerSettingRaw) {
    return new CustomFieldLedgerSetting(ledgerType.toEnum(raw.ledger), raw.detail);
  }
}

class CustomFieldLedgerSettingDetail
  implements Pick<CustomField['schema'], 'displayOrder' | 'customField' | 'isRequired'>
{
  private constructor(
    readonly displayOrder: number,
    readonly customField: string,
    readonly isRequired: boolean,
  ) {}

  static fromRaw(raw: CustomFieldLedgerSettingDetailRaw) {
    return new CustomFieldLedgerSettingDetail(raw.displayOrder, raw.customField, raw.isRequired);
  }
}

class CustomFieldLedgerSettingRaw implements Pick<CustomField['record'], 'ledger'> {
  private constructor(
    readonly ledger: string,
    readonly detail: CustomFieldLedgerSettingDetailRaw[],
  ) {}

  static fromModel(model: CustomFieldLedgerSetting) {
    return new CustomFieldLedgerSettingRaw(model.ledger, model.detail);
  }
}

class CustomFieldLedgerSettingDetailRaw
  implements Pick<CustomField['record'], 'displayOrder' | 'customField' | 'isRequired'>
{
  private constructor(
    readonly displayOrder: number,
    readonly customField: string,
    readonly isRequired: boolean,
  ) {}

  static fromModel(model: CustomFieldLedgerSettingDetail) {
    return new CustomFieldLedgerSettingDetailRaw(
      model.displayOrder,
      model.customField,
      model.customField === '' ? false : model.isRequired,
    );
  }
}

export {
  CustomFieldLedgerSetting,
  CustomFieldLedgerSettingDetail,
  CustomFieldLedgerSettingDetailRaw,
  CustomFieldLedgerSettingRaw,
};
